import config from 'config'
import React, { useState, useEffect } from 'react'
import { css } from '@emotion/react'
import cn from 'classnames'
import ReactCSSTransitionReplace from 'react-css-transition-replace'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import GTM from 'react-gtm-module'
import { Button, SubHeader } from 'shared/ui'
import { Form } from 'util/ui'
import { propFunc } from 'util/functions'
import storage from 'util/storage'
import themeVars from 'ui_theme/site/globals/site.variables'

import OnboardingButton from '../Button'
import PageHeader from '../PageHeader'
import sharedStyles from '../../sharedForm/styles.less'

function forceRefreshRedirect(customerAccountUrl) {
  // HACK (jscheel): Log out app subdomain in preparation for going to account subdomain
  if (storage.isAvailable()) {
    storage.cleanupAppStorage()
  }
  window.location = customerAccountUrl
}

const buttonStyle = () => theme => css`
  &&& {
    background-color: #f4f8fc !important;
    color: ${theme.color.monochrome.superDark};
    margin-top: 0 !important;
    font-family: ${props => props.theme.font.primary} !important;
    font-size: ${props => props.theme.spacing['10']} !important;
    line-height: 1 !important;
    padding-top: ${themeVars.relative15px} !important;
    padding-bottom: ${themeVars.relative15px} !important;
  }
`

const AccountUrl = ({ url }) => {
  const [copied, setCopied] = useState(false)
  useEffect(
    () => {
      const timer = setTimeout(() => setCopied(false), 2000)
      return () => clearTimeout(timer)
    },
    [copied]
  )

  return (
    // eslint-disable-next-line react/jsx-no-bind
    <CopyToClipboard text={url} onCopy={() => setCopied(true)}>
      <ReactCSSTransitionReplace
        transitionName="fade-wait"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
        overflowHidden={false}
      >
        <Button
          key={copied ? 'copied' : 'normal'}
          size="big"
          fluid
          css={buttonStyle}
          primary={false}
        >
          {copied ? 'copied to clipboard' : url}
        </Button>
      </ReactCSSTransitionReplace>
    </CopyToClipboard>
  )
}

const CompletionPage = ({ accountUrl, autoLoginUrl, setCompleteFlag }) => {
  useEffect(() => {
    setCompleteFlag()
    GTM.dataLayer({
      dataLayer: {
        event: 'groove_signupcompleted_event',
      },
      dataLayerName: 'PageDataLayer',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <React.Fragment>
      <PageHeader
        primary={`Your ${config.trialDays} day free trial is ready!`}
      />
      <Form size="large" className={cn(sharedStyles.form, sharedStyles.formV2)}>
        <Form.Field>
          <AccountUrl url={accountUrl} />
        </Form.Field>
        <Form.Field>
          <SubHeader size="tiny" as="p" color="dark">
            This is where you will be able to access your brand-spanking new
            account in the future.
            <br />
            <br />
            Make sure you bookmark it once you’re inside.
          </SubHeader>
        </Form.Field>
        <OnboardingButton
          onClick={propFunc(forceRefreshRedirect, autoLoginUrl)}
        >
          Take me to my account
        </OnboardingButton>
      </Form>
    </React.Fragment>
  )
}

export default CompletionPage
